<template>
    <div class="publish-center">
        <h2 class="page-title">实战超市后台数据发布中心</h2>

        <el-form :model="form" :rules="rules" ref="form" label-width="120px" class="publish-form" size="small">

            <!-- 1、彩种 + 下一期开奖 -->
            <el-form-item label="1、期号信息" prop="preType" class="inline-item">
                <div class="inline-row">
                    <el-select v-model="form.preType" placeholder="彩种" style="width: 120px;" @change="onPreTypeChange">
                        <el-option v-for="item in lotteryList" :key="item.dictValue" :label="item.dictLabel"
                            :value="item.dictValue"></el-option>
                    </el-select>
                    <span class="field-label">下一期开奖</span>
                    <el-input v-model="form.preNumber" placeholder="切换彩种自动获取" style="width: 160px;" :disabled="true" />
                </div>
            </el-form-item>

            <!-- 2、选择团队 -->
            <el-form-item label="2、选择团队" prop="teamId" class="team-select-item">
                <div class="team-toolbar">
                    <el-button type="primary" plain size="small" icon="el-icon-plus"
                        @click="openAddTeam">增加团队</el-button>
                    <span v-if="form.preType !== '' && form.preType != null" class="team-filter-tip">
                        已按「{{ preTypeLabel(form.preType) }}」筛选，共 {{ filteredTeamList.length }} 个可用团队
                    </span>
                </div>
                <el-table ref="teamTable" class="team-table" :data="filteredTeamList" border highlight-current-row
                    @current-change="onCurrentTeamChange" :empty-text="teamEmptyText"
                    :header-cell-style="{ background: '#347caf', color: '#fff', textAlign: 'center' }"
                    :cell-style="{ textAlign: 'center' }">
                    <el-table-column label="" width="45">
                        <template slot-scope="scope">
                            <el-radio v-model="form.teamId" :label="scope.row.id">&nbsp;</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="teamName" label="团队名称" min-width="100"></el-table-column>
                    <el-table-column prop="teamSlogan" label="团队口号" min-width="140"></el-table-column>
                    <el-table-column label="支持彩种" min-width="120">
                        <template slot-scope="scope">
                            <span>{{ teamPreTypeText(scope.row) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="团队累计税后总额" min-width="130">
                        <template slot-scope="scope">
                            <el-input v-if="form.teamId === scope.row.id" v-model="scope.row.teamTotalAfterTaxAmount"
                                size="mini" @input="onTeamAmountInput(scope.row)" placeholder="可输入数字/小数"
                                :key="'team-amount-' + form.teamId"></el-input>
                            <span v-else>{{ scope.row.teamTotalAfterTaxAmount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="团队成员" width="90">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="viewTeamMembers(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" style="color:#f56c6c"
                                @click="handleDeleteTeam(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>

            <!-- 3、标题 -->
            <el-form-item label="3、方案标题" prop="title">
                <el-input v-model="form.title" placeholder="请输入实战方案标题" />
            </el-form-item>

            <!-- 4、文件上传 -->
            <el-form-item label="4、方案文件" prop="schemeFileId">
                <div class="upload-row">
                    <el-upload action="" :auto-upload="false" :show-file-list="false" :on-change="handleFileChange">
                        <el-button type="primary" plain size="small">
                            <i class="el-icon-folder-opened"></i> 上传方案文件
                        </el-button>
                    </el-upload>
                    <span v-if="form.schemeFileName" class="file-name">{{ form.schemeFileName }}</span>
                </div>
            </el-form-item>

            <!-- 5、方案参数 -->
            <el-form-item label="5、方案参数" prop="coin" class="param-item">
                <div class="param-line">
                    <span class="param-label">方案价格</span>
                    <el-input v-model="form.coin" placeholder="请输入方案价格" style="width: 200px;">
                        <template slot="suffix">缩币</template>
                    </el-input>
                </div>
                <div class="param-line">
                    <span class="param-label">上期税后总额</span>
                    <el-input v-model="form.lastAfterTaxAmount" placeholder="如：100-50+200..." style="width: 200px;" />
                </div>
                <div class="param-line">
                    <span class="param-label">盈亏状态</span>
                    <el-input v-model="form.plStatus" placeholder="如：+500" style="width: 200px;" />
                </div>
                <div class="param-line">
                    <span class="param-label">限购</span>
                    <el-input v-model="form.purchaseLimit" placeholder="请输入限购数量" style="width: 200px;">
                        <template slot="suffix">份</template>
                    </el-input>
                </div>
                <div class="param-line">
                    <span class="param-label">团队累计税后总额</span>
                    <el-input v-model="form.teamTotalAfterTaxAmount" placeholder="团队累计税后总额" style="width: 200px;"
                        :disabled="true" />
                </div>
            </el-form-item>

            <!-- 6、预测说明 -->
            <el-form-item label="6、预测说明" prop="illustrate">
                <el-input type="textarea" v-model="form.illustrate" :rows="3" placeholder="请输入预测说明" />
            </el-form-item>

            <el-form-item label-width="0" style="text-align: center;">
                <el-button type="primary" :loading="publishLoading" @click="submitPublish">确认发布</el-button>
            </el-form-item>
        </el-form>

        <!-- 增加团队弹窗 -->
        <el-dialog title="增加团队" :visible.sync="teamDialogVisible" width="540px" append-to-body>
            <el-form :model="teamForm" label-width="90px" size="small">
                <el-form-item label="团队名称" required>
                    <el-input v-model="teamForm.teamName" placeholder="请输入团队名称" />
                </el-form-item>
                <el-form-item label="团队口号" required>
                    <el-input v-model="teamForm.teamSlogan" placeholder="请输入团队口号" />
                </el-form-item>
                <el-form-item label="联系方式" required>
                    <el-input v-model="teamForm.teamContact" placeholder="请输入联系方式" />
                </el-form-item>
                <el-form-item label="团队介绍" required>
                    <el-input type="textarea" v-model="teamForm.teamIntro" :rows="3" placeholder="请输入团队介绍/战绩描述" />
                </el-form-item>
                <el-form-item label="团队成员">
                    <el-table ref="memberTable" class="member-table" :data="memberTableData" border size="mini"
                        :row-key="row => row.userId" @selection-change="onMemberSelectionChange"
                        :header-cell-style="{ background: '#347caf', color: '#fff', textAlign: 'center' }"
                        :cell-style="{ textAlign: 'center' }">
                        <el-table-column type="selection" width="42" :reserve-selection="true"></el-table-column>
                        <el-table-column label="成员姓名" min-width="100">
                            <template slot-scope="scope">{{ scope.row.nickName || scope.row.userName }}</template>
                        </el-table-column>
                        <el-table-column prop="phonenumber" label="手机号" min-width="110"></el-table-column>
                        <el-table-column prop="userName" label="账号" min-width="100"></el-table-column>
                    </el-table>
                    <el-pagination class="member-pager" @current-change="onMemberPageChange"
                        :current-page="memberPageNum" :page-size="memberPageSize" :total="allUsers.length"
                        layout="prev, pager, next, total" small>
                    </el-pagination>

                    <div v-if="selectedMembers.length" class="selected-members">
                        <div class="sel-title">已选成员（{{ selectedMembers.length }}）</div>
                        <el-table class="sel-table" :data="selectedMembers" border size="mini"
                            :header-cell-style="{ background: '#347caf', color: '#fff', textAlign: 'center' }"
                            :cell-style="{ textAlign: 'center' }">
                            <el-table-column label="成员姓名" min-width="100">
                                <template slot-scope="scope">{{ scope.row.memberName }}</template>
                            </el-table-column>
                            <el-table-column label="类型" min-width="80">
                                <template slot-scope="scope">{{ scope.row.memberType === '1' ? '技巧师' : '缩水师'
                                    }}</template>
                            </el-table-column>
                            <el-table-column label="操作" width="70">
                                <template slot-scope="scope">
                                    <el-button type="text" size="mini" style="color:#f56c6c"
                                        @click="removeSelectedMember(scope.$index)">移除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="teamDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="teamSaving" @click="submitAddTeam">确定</el-button>
            </div>
        </el-dialog>

        <!-- 团队成员查看弹窗 -->
        <el-dialog title="团队成员" :visible.sync="memberViewVisible" width="640px" append-to-body>
            <el-table :data="currentTeamMembers" border size="mini"
                :header-cell-style="{ background: '#347caf', color: '#fff', textAlign: 'center' }"
                :cell-style="{ textAlign: 'center' }">
                <el-table-column prop="memberName" label="姓名" min-width="90"></el-table-column>
                <el-table-column prop="memberPhone" label="手机号" min-width="130"></el-table-column>
                <el-table-column prop="memberEmail" label="邮箱" min-width="220"></el-table-column>
            </el-table>
            <div slot="footer">
                <el-button @click="memberViewVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { queryLotteryType, queryUuIdInfo } from '@/api/common'
import { addTeam, deleteTeam, getMyTeam, getUserByRole, GetLotteryList, publishScheme, updateScheme, getNextPeriod } from '@/api/personalCenter'

export default {
    name: 'RepresentativeApply',
    props: {
        // 编辑模式传入的方案行数据；为空则为发布模式
        editData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            lotteryList: [],
            teamList: [],
            publishLoading: false,
            uploadingField: '',
            suppressTeamChange: false,
            editTeamSelected: false,
            teamDialogVisible: false,
            teamSaving: false,
            allUsers: [],
            memberPageNum: 1,
            memberPageSize: 8,
            selectedMembers: [],
            memberViewVisible: false,
            currentTeamMembers: [],
            teamForm: {
                teamName: '',
                teamSlogan: '',
                teamContact: '',
                teamIntro: ''
            },

            form: {
                id: '',
                preType: '',
                preNumber: '',
                teamId: '',
                teamName: '',
                teamSlogan: '',
                teamTotalAfterTaxAmount: '',
                title: '',
                schemeFileId: '',
                schemeFileName: '',
                coin: 0,
                lastAfterTaxAmount: '',
                plStatus: '',
                purchaseLimit: 5,
                illustrate: ''
            },

            rules: {
                preType: [{ required: true, message: '请选择彩种', trigger: 'change' }],
                preNumber: [{ required: true, message: '请输入期号', trigger: 'blur' }],
                teamId: [{ required: true, message: '请选择团队', trigger: 'change' }],
                title: [
                    { required: true, message: '请填写标题', trigger: 'blur' },
                    { min: 6, message: '标题至少6个字', trigger: 'blur' }
                ],
                schemeFileId: [{ required: true, message: '请上传方案文件', trigger: 'change' }],
                coin: [{ required: true, message: '请填写方案价格', trigger: 'change' }],
                purchaseLimit: [{ required: true, message: '请填写限购数量', trigger: 'change' }],
                illustrate: [{ required: true, message: '请填写预测说明', trigger: 'blur' }]
            }
        }
    },
    computed: {
        // 成员表格当前页数据（前端分页）
        memberTableData() {
            const start = (this.memberPageNum - 1) * this.memberPageSize
            return this.allUsers.slice(start, start + this.memberPageSize)
        },
        // 是否编辑模式
        editMode() {
            return !!this.editData
        },
        // 按当前所选彩种筛选团队：团队未登记彩种视为"不限"，登记了则必须登记过当前彩种才显示
        filteredTeamList() {
            const pt = (this.form.preType === '' || this.form.preType == null) ? '' : String(this.form.preType)
            if (!pt) return this.teamList
            return this.teamList.filter(t => {
                const preTypes = Array.isArray(t.preTypes) ? t.preTypes : []
                return preTypes.length === 0 || preTypes.indexOf(pt) !== -1
            })
        },
        // 团队表格空数据文案：区分"没有团队"与"没有支持当前彩种的团队"
        teamEmptyText() {
            const pt = (this.form.preType === '' || this.form.preType == null) ? '' : String(this.form.preType)
            if (!this.teamList.length) return '暂无团队，请点击左上角「增加团队」创建'
            if (pt && !this.filteredTeamList.length) {
                return '暂无支持「' + this.preTypeLabel(pt) + '」的团队，请切换彩种或新建团队'
            }
            return '暂无数据'
        }
    },
    methods: {
        // 加载彩种（只取双色球、大乐透）
        loadLotteryList() {
            queryLotteryType().then(res => {
                const list = Array.isArray(res) ? res : (res && Array.isArray(res.data) ? res.data : [])
                this.lotteryList = list.filter(item => item.dictValue === '0' || item.dictValue === '1')
                if (this.lotteryList.length && !this.form.preType) {
                    this.form.preType = this.lotteryList[0].dictValue
                    // 彩种确定后自动获取下一期开奖期号
                    this.loadNextPeriod()
                }
            }).catch(() => {
                this.lotteryList = []
            })
        },

        // 根据彩种自动获取下一期开奖期号（GET /stage-api/lottery/result/next/period，type: 0双色球 1大乐透）
        loadNextPeriod() {
            if (this.form.preType === '' || this.form.preType == null) return
            getNextPeriod(Number(this.form.preType)).then(res => {
                const base = res && res.data !== undefined ? res.data : res
                const period = base && base.nextPeriod
                if (period != null && period !== '') {
                    this.form.preNumber = String(period)
                } else {
                    this.form.preNumber = ''
                }
            }).catch(() => {
                this.form.preNumber = ''
            })
        },

        // 加载团队列表（我的团队，接口在弹窗外调用）
        loadTeamList() {
            getMyTeam().then(res => {
                const base = res && res.data !== undefined ? res.data : res
                let list = []
                if (Array.isArray(base)) list = base
                else if (base && Array.isArray(base.rows)) list = base.rows
                else if (base && Array.isArray(base.list)) list = base.list
                else if (base && Array.isArray(base.data)) list = base.data
                this.teamList = this.flatTeamList(list)
                // 团队累计税后总额按"方案"填写，不预填团队接口自带的值，
                // 避免非选中团队也在该列显示数字（进入编辑时只应回填"当前选中团队"那一行的方案值）
                this.teamList.forEach(t => { t.teamTotalAfterTaxAmount = '' })
                // 编辑模式：团队列表加载完成后自动选中回填的团队行
                this.editTeamSelected = false
                this.$nextTick(() => this.selectEditTeam())
            }).catch(() => {
                this.teamList = []
            })
        },

        // 编辑模式：根据编辑记录里的 teamId / teamName 在团队列表中选中对应的团队行
        selectEditTeam() {
            if (!this.editMode) return
            if (!this.teamList.length) {
                // 团队列表尚未加载完成，稍后重试
                setTimeout(() => this.selectEditTeam(), 100)
                return
            }
            if (this.editTeamSelected) return
            const tid = this.form.teamId
            const tname = this.form.teamName
            // 打印真实数据结构，便于精确对齐字段名（定位用，定位后可删）
            // eslint-disable-next-line no-console
            console.log('[selectEditTeam DEBUG] formTeamId=', tid, 'formTeamName=', tname,
                'editDataTeam=', this.editData ? {
                    teamId: this.editData.teamId, teamName: this.editData.teamName,
                    team: this.editData.team, id: this.editData.id, marketId: this.editData.marketId
                } : null,
                'teams=', this.teamList.slice(0, 5).map(t => ({ id: t.id, teamId: t.teamId, teamName: t.teamName, keys: Object.keys(t) })))

            let matched = null
            // 1) 标准匹配：按 id（兼容 id / teamId）/ 按 name（兼容 teamName / name）
            if (tid != null && tid !== '') {
                matched = this.teamList.find(t => String(t.id) === String(tid) || String(t.teamId) === String(tid))
            }
            if (!matched && tname) {
                matched = this.teamList.find(t => (t.teamName || '') === tname || (t.name || '') === tname)
            }
            // 2) 自适应兜底：遍历每行所有字段，命中任意字段值等于目标值（应对未知字段名）
            if (!matched && tid != null && tid !== '') {
                matched = this.teamList.find(t => Object.keys(t).some(k => {
                    const v = t[k]
                    return v != null && String(v) === String(tid)
                }))
            }
            if (!matched && tname) {
                matched = this.teamList.find(t => Object.keys(t).some(k => {
                    const v = t[k]
                    return typeof v === 'string' && v.trim() === String(tname).trim()
                }))
            }
            if (!matched) {
                // eslint-disable-next-line no-console
                console.warn('[selectEditTeam] 未匹配到团队，请核对字段名', { formTeamId: tid, formTeamName: tname })
                return
            }
            this.editTeamSelected = true
            // 用选中行的 id 回填，保证 radio 勾选与表单一致（兼容 id / teamId）
            const selId = matched.id != null ? matched.id : (matched.teamId != null ? matched.teamId : '')
            this.form.teamId = selId
            // 编辑回填兜底：若该团队登记的彩种不含当前方案的彩种，自动切到团队支持的第一个彩种，
            // 否则该团队会被彩种筛选过滤掉、表格里看不到已选中的行
            const editPreTypes = Array.isArray(matched.preTypes) ? matched.preTypes : []
            if (editPreTypes.length && editPreTypes.indexOf(String(this.form.preType)) === -1) {
                const target = editPreTypes[0]
                this.$message.warning('当前方案的「' + this.preTypeLabel(this.form.preType) + '」该团队不支持，已切换为「' + this.preTypeLabel(target) + '」')
                this.form.preType = target
                this.loadNextPeriod()
            }
            // 编辑回填：把编辑记录里的团队累计税后总额只赋给"当前选中的这一条"团队行
            if (this.form.teamTotalAfterTaxAmount !== '' && this.form.teamTotalAfterTaxAmount != null) {
                matched.teamTotalAfterTaxAmount = this.form.teamTotalAfterTaxAmount
            }
            this.handleTeamChange(matched)
            // 反复尝试 setCurrentRow，直到对话框过渡动画结束、表格渲染就绪
            this.applyTeamCurrentRow(matched)
        },

        // 反复尝试 setCurrentRow，覆盖对话框展开动画期间表格尚未就绪的情况（最多约 1.2s）
        applyTeamCurrentRow(matched) {
            let tries = 0
            const attempt = () => {
                this.suppressTeamChange = true
                this.$nextTick(() => {
                    const table = this.$refs.teamTable
                    if (table) table.setCurrentRow(matched)
                    this.$nextTick(() => { this.suppressTeamChange = false })
                    tries += 1
                    if (tries < 15) setTimeout(attempt, 80)
                })
            }
            attempt()
        },

        // 加载可选成员列表（按角色查询用户，接口在弹窗外调用）
        loadMemberOptions() {
            getUserByRole().then(res => {
                const base = res && res.data !== undefined ? res.data : res
                let list = []
                if (Array.isArray(base)) list = base
                else if (base && Array.isArray(base.rows)) list = base.rows
                else if (base && Array.isArray(base.list)) list = base.list
                this.allUsers = list
                this.memberPageNum = 1
            }).catch(() => {
                this.allUsers = []
            })
        },

        flatTeamList(list) {
            if (!Array.isArray(list)) return []
            return list.map(t => {
                const amount = t.teamTotalAfterTaxAmount != null ? t.teamTotalAfterTaxAmount
                    : (t.teamTotalAfterTax != null ? t.teamTotalAfterTax
                        : (t.teamAfterTaxAmount != null ? t.teamAfterTaxAmount
                            : (t.totalAfterTaxAmount != null ? t.totalAfterTaxAmount : '')))
                return {
                    ...t,
                    // 归一化：兼容接口返回 id / teamId 两种字段名
                    id: t.id != null ? t.id : (t.teamId != null ? t.teamId : ''),
                    teamId: t.teamId != null ? t.teamId : (t.id != null ? t.id : ''),
                    // 归一化：兼容 teamName / name 两种字段名
                    teamName: t.teamName || t.name || '',
                    teamSlogan: t.teamSlogan || t.slogan || '',
                    // 团队可发布的彩种编码列表（0双色球/1大乐透），用于选团队后联动校验彩种
                    preTypes: Array.isArray(t.preTypes) ? t.preTypes.map(String) : [],
                    teamTotalAfterTaxAmount: amount
                }
            })
        },

        onPreTypeChange() {
            this.form.teamId = ''
            this.form.teamName = ''
            this.form.teamSlogan = ''
            this.form.teamTotalAfterTaxAmount = ''
            this.form.preNumber = ''
            this.loadTeamList()
            this.loadNextPeriod()
        },

        // 彩种编码转名称（0双色球/1大乐透），用于提示文案
        preTypeLabel(v) {
            const hit = this.lotteryList.find(item => String(item.dictValue) === String(v))
            return hit ? hit.dictLabel : (v === '0' ? '双色球' : v === '1' ? '大乐透' : v)
        },

        // 团队支持彩种展示文案：未登记彩种的团队按"不限"处理
        teamPreTypeText(row) {
            const preTypes = row && Array.isArray(row.preTypes) ? row.preTypes : []
            if (!preTypes.length) return '不限'
            return preTypes.map(v => this.preTypeLabel(v)).join('、')
        },

        // 表格行切换：手动点击选中时触发，把当前行数据同步到表单
        onCurrentTeamChange(currentRow, oldRow) {
            // 屏蔽程序调用 setCurrentRow 自动触发的 current-change，避免误清空已回填的字段
            if (this.suppressTeamChange) return
            if (!currentRow) return
            if (oldRow && String(currentRow.id) === String(oldRow.id)) return
            this.handleTeamChange(currentRow)
            // 编辑模式：切换到的团队若未填写"团队累计税后总额"，给出提示（提交时再硬性拦截）
            if (this.editMode && this.isAmountEmpty(currentRow.teamTotalAfterTaxAmount)) {
                this.$message.warning('请填写该团队的累计税后总额')
            }
        },

        // 判断"团队累计税后总额"是否未填写（空串 / null / undefined 视为未填写；0 视为已填写）
        isAmountEmpty(v) {
            return v === '' || v == null
        },

        handleTeamChange(row) {
            if (!row) return
            this.form.teamId = row.id
            this.form.teamName = row.teamName
            this.form.teamSlogan = row.teamSlogan
            // 注：彩种改由第 1 步主控（选彩种自动筛选团队），此处不再反向联动彩种
            // 团队累计税后总额：编辑模式跟随选中团队行（含回填值）；发布模式保持空，由用户填写
            this.form.teamTotalAfterTaxAmount = (this.editMode && row.teamTotalAfterTaxAmount != null) ? row.teamTotalAfterTaxAmount : ''
            // 带出团队上期战绩（如有）
            GetLotteryList({ teamName: row.teamName, preType: this.form.preType }).then(res => {
                const list = Array.isArray(res) ? res : (res && Array.isArray(res.data) ? res.data : [])
                if (list.length) {
                    const last = list[0]
                    this.form.lastAfterTaxAmount = last.lastAfterTaxAmount || ''
                    this.form.plStatus = last.plStatus || ''
                }
            }).catch(() => { })
        },

        // 第二步团队表格内编辑"团队累计税后总额"：仅选中行可输入，限制数字+小数，同步到表单
        onTeamAmountInput(row) {
            let v = String(row.teamTotalAfterTaxAmount).replace(/[^0-9.]/g, '')
            const parts = v.split('.')
            if (parts.length > 2) {
                v = parts[0] + '.' + parts.slice(1).join('')
            }
            row.teamTotalAfterTaxAmount = v
            // 仅当编辑的是当前选中团队时，同步到表单（第五步只读展示 + 提交用）
            if (this.form.teamId === row.id) {
                this.form.teamTotalAfterTaxAmount = v
            }
        },

        // 查看某条团队数据里的成员列表
        viewTeamMembers(row) {
            const list = row && Array.isArray(row.memberList) ? row.memberList : []
            this.currentTeamMembers = list
            this.memberViewVisible = true
        },

        // 打开新增团队弹窗
        openAddTeam() {
            this.teamForm = {
                teamName: '',
                teamSlogan: '',
                teamContact: '',
                teamIntro: ''
            }
            this.selectedMembers = []
            this.memberPageNum = 1
            this.teamDialogVisible = true
            this.loadMemberOptions()
            this.$nextTick(() => {
                if (this.$refs.memberTable) this.$refs.memberTable.clearSelection()
            })
        },

        // 成员表格勾选变化（跨页保留，reserve-selection）
        onMemberSelectionChange(rows) {
            const map = {}
            this.selectedMembers.forEach(m => { map[m.memberUserId] = m })
            this.selectedMembers = rows.map(u => {
                const id = u.userId
                if (map[id]) return map[id] // 保留已设类型
                return {
                    memberUserId: id,
                    memberName: u.nickName || u.userName || '',
                    memberType: '0'
                }
            })
        },

        // 成员表格翻页
        onMemberPageChange(page) {
            this.memberPageNum = page
        },

        // 从已选列表移除成员（同步取消表格勾选）
        removeSelectedMember(index) {
            const m = this.selectedMembers[index]
            this.selectedMembers.splice(index, 1)
            const row = this.memberTableData.find(u => u.userId === m.memberUserId)
            if (row && this.$refs.memberTable) {
                this.$refs.memberTable.toggleRowSelection(row, false)
            }
        },

        // 提交新增团队
        submitAddTeam() {
            if (!this.teamForm.teamName) {
                this.$message.warning('请填写团队名称')
                return
            }
            if (!this.teamForm.teamSlogan) {
                this.$message.warning('请填写团队口号')
                return
            }
            if (!this.teamForm.teamContact) {
                this.$message.warning('请填写联系方式')
                return
            }
            if (!this.teamForm.teamIntro) {
                this.$message.warning('请填写团队介绍')
                return
            }
            const validMembers = this.selectedMembers.filter(m => m.memberUserId)
            if (!validMembers.length) {
                this.$message.warning('请至少选择一名团队成员')
                return
            }
            const payload = {
                teamName: this.teamForm.teamName,
                teamSlogan: this.teamForm.teamSlogan,
                teamContact: this.teamForm.teamContact,
                teamIntro: this.teamForm.teamIntro,
                preType: this.form.preType ? [this.form.preType] : [],
                memberList: validMembers.map(m => ({
                    memberName: m.memberName,
                    memberType: m.memberType,
                    memberUserId: m.memberUserId
                }))
            }
            this.teamSaving = true
            addTeam(payload).then(res => {
                this.teamSaving = false
                if (res && res.code == 200) {
                    this.$message.success('添加成功')
                    this.teamDialogVisible = false
                    this.loadTeamList()
                } else {
                    this.$message.error((res && res.msg) || '添加失败')
                }
            }).catch(() => {
                this.teamSaving = false
            })
        },

        // 删除已选团队
        handleDeleteTeam(row) {
            const id = row ? row.id : this.form.teamId
            if (!id) {
                this.$message.warning('请先选择要删除的团队')
                return
            }
            const name = row ? (row.teamName || '') : (this.form.teamName || '')
            this.$confirm('确认删除团队「' + name + '」？', '提示', { type: 'warning' }).then(() => {
                deleteTeam({ id }).then(res => {
                    if (res && res.code == 200) {
                        this.$message.success('删除成功')
                        if (this.form.teamId == id) {
                            this.form.teamId = ''
                            this.form.teamName = ''
                            this.form.teamSlogan = ''
                            this.form.teamTotalAfterTaxAmount = ''
                        }
                        this.loadTeamList()
                    } else {
                        this.$message.error((res && res.msg) || '删除失败')
                    }
                }).catch(() => { })
            }).catch(() => { })
        },

        // 统一上传文件，返回 fileId（上传接口 /stage-api/commonFile/upLoadFile 的 res.data.fileId）
        uploadSchemeFile(file, cb) {
            if (!file || !file.raw) return
            const fd = new FormData()
            fd.append('file', file.raw)
            const ft = 'representative_scheme'
            const params = `?fileType=${ft}&bizId=${this.form.id}&number=${ft}`
            this.uploadingField = 'file'
            this.$utils.upLoadFile(params, fd).then(res => {
                const fileId = res && res.data && res.data.fileId != null ? res.data.fileId : ''
                this.uploadingField = ''
                cb && cb(fileId, file.name)
            }).catch(() => {
                this.uploadingField = ''
            })
        },

        handleFileChange(file) {
            this.uploadSchemeFile(file, (url, name) => {
                this.form.schemeFileId = url
                this.form.schemeFileName = name
            })
        },

        buildPayload() {
            const payload = {
                id: this.form.id,
                coin: Number(this.form.coin) || 0,
                illustrate: this.form.illustrate,
                lastAfterTaxAmount: this.form.lastAfterTaxAmount,
                pageNum: 1,
                pageSize: 999,
                plStatus: this.form.plStatus,
                preNumber: this.form.preNumber,
                preType: this.form.preType,
                purchaseLimit: Number(this.form.purchaseLimit) || 0,
                schemeFileId: this.form.schemeFileId,
                teamId: this.form.teamId,
                teamName: this.form.teamName,
                teamSlogan: this.form.teamSlogan,
                teamTotalAfterTaxAmount: this.form.teamTotalAfterTaxAmount,
                title: this.form.title
            }
            return payload
        },

        submitPublish() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    this.$message.error('请完善必填项')
                    return
                }
                // 编辑模式（含切换团队后）：必须填写团队累计税后总额，否则拦截提交
                if (this.isAmountEmpty(this.form.teamTotalAfterTaxAmount)) {
                    this.$message.warning('请先填写团队累计税后总额后再提交')
                    return
                }
                this.publishLoading = true
                // 编辑模式走 updateScheme，发布模式走 publishScheme
                const api = this.editMode ? updateScheme : publishScheme
                api(this.buildPayload()).then(res => {
                    this.publishLoading = false
                    if (res && res.code == 200) {
                        this.$message.success(this.editMode ? '修改成功' : '发布成功')
                        // 通知父组件（列表页）关闭弹窗并刷新
                        this.$emit('published')
                        if (!this.editMode) this.resetForm()
                    } else {
                        this.$message.error((res && res.msg) || (this.editMode ? '修改失败' : '发布失败'))
                    }
                }).catch(() => {
                    this.publishLoading = false
                })
            })
        },

        // 编辑模式：用列表行数据回填表单
        fillEditForm(row) {
            const f = this.form
            f.id = (row.marketId != null ? row.marketId : row.id) || ''
            f.preType = row.preType != null ? String(row.preType) : ''
            f.preNumber = row.preNumber || ''
            f.teamId = row.teamId != null ? row.teamId : (row.team != null ? row.team.id : '')
            f.teamName = row.teamName || ''
            f.teamSlogan = row.teamSlogan || ''
            // 兼容可能的后端字段名：优先 teamTotalAfterTaxAmount，再试 teamTotalAfterTax/teamAfterTaxAmount/totalAfterTaxAmount，最后试 row.team.xxx
            const teamAmount = row.teamTotalAfterTaxAmount != null ? row.teamTotalAfterTaxAmount
                : (row.teamTotalAfterTax != null ? row.teamTotalAfterTax
                    : (row.teamAfterTaxAmount != null ? row.teamAfterTaxAmount
                        : (row.totalAfterTaxAmount != null ? row.totalAfterTaxAmount
                            : (row.team && row.team.teamTotalAfterTaxAmount != null ? row.team.teamTotalAfterTaxAmount : ''))))
            f.teamTotalAfterTaxAmount = teamAmount
            f.title = row.title || ''
            f.schemeFileId = row.schemeFileId || ''
            f.schemeFileName = row.schemeFileName || (row.schemeFileId ? '已上传文件' : '')
            f.coin = row.coin != null ? row.coin : 0
            f.lastAfterTaxAmount = row.lastAfterTaxAmount || ''
            f.plStatus = row.plStatus || ''
            f.purchaseLimit = row.purchaseLimit != null ? row.purchaseLimit : 5
            f.illustrate = row.illustrate || ''
        },

        resetForm() {
            this.$refs.form.resetFields()
            this.form.schemeFileName = ''
            this.form.teamName = ''
            this.form.teamSlogan = ''
            this.form.teamTotalAfterTaxAmount = ''
            this.form.preNumber = ''
            queryUuIdInfo().then(res => {
                this.form.id = res
            })
            if (this.lotteryList.length) {
                this.form.preType = this.lotteryList[0].dictValue
                this.loadTeamList()
                this.loadNextPeriod()
            }
        }
    },
    mounted() {
        if (this.editData) {
            // 编辑模式：回填表单并拉取下一期（满足下一期开奖接口需调用）
            this.fillEditForm(this.editData)
            this.loadNextPeriod()
            // 兜底：对话框展开动画结束后再尝试选中团队，避免表格尚未就绪导致 setCurrentRow 失效
            setTimeout(() => this.selectEditTeam(), 500)
        } else {
            queryUuIdInfo().then(res => {
                this.form.id = res
            })
        }
        this.loadLotteryList()
        this.loadTeamList()
        this.loadMemberOptions()
    }
}
</script>

<style lang="scss" scoped>
.publish-center {
    padding: 14px;
    background: #fff;

    .page-title {
        text-align: center;
        font-size: 17px;
        color: #fff;
        background: #347caf;
        padding: 8px 0;
        margin: 0 0 14px 0;
        border-radius: 4px;
    }

    .publish-form {
        .el-form-item {
            margin-bottom: 12px;
        }
    }

    ::v-deep .el-table td,
    ::v-deep .el-table th {
        padding: 4px 0;
        font-size: 13px;
    }

    ::v-deep .el-table .cell {
        line-height: 18px;
        padding-left: 6px;
        padding-right: 6px;
    }

    .inline-row {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
    }

    .field-label {
        color: #4a5a70;
        font-size: 13px;
        white-space: nowrap;
    }

    .team-toolbar {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 8px;
    }

    .team-filter-tip {
        font-size: 12px;
        color: #347caf;
    }

    .member-table {

        ::v-deep .el-table__header th,
        ::v-deep .el-table__body td {
            padding: 3px 0;
            font-size: 12px;
        }
    }

    .member-pager {
        margin-top: 6px;
        text-align: right;
    }

    .selected-members {
        margin-top: 10px;

        .sel-title {
            font-size: 12px;
            color: #347caf;
            font-weight: 500;
            margin-bottom: 6px;
        }

        .sel-table {

            ::v-deep .el-table__header th,
            ::v-deep .el-table__body td {
                padding: 3px 0;
                font-size: 12px;
            }
        }
    }

    .param-line {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 8px;

        &:last-child {
            margin-bottom: 0;
        }

        .param-label {
            width: 110px;
            color: #4a5a70;
            font-size: 13px;
            text-align: right;
        }
    }

    .upload-row {
        display: flex;
        align-items: center;
        gap: 10px;

        .file-name {
            color: #67c23a;
            font-size: 13px;
        }
    }
}
</style>
